<template>
  <div class="ts-overflow-scroll ts-max-h-screen">
    <div class="ts-flex ts-justify-start ts-mb-2">
      <ts-input
        v-model="search"
        :placeholder="$t('search')"
        style="width: 250px"
      />
    </div>
    <ts-table :columns="columns" :records="filteredStudents">
      <template v-slot="{ record, index }">
        <td style="vertical-align: middle;">
          {{ index + 1 }}
        </td>
        <td style="vertical-align: middle;">{{ record.card_number }}</td>
        <td>
          <img
            class="ts-w-10 ts-rounded-sm ts-shadow-md"
            v-lazy="{
              src: photo(record),
              error: photoError,
              loading: require('@/assets/Rolling-1s-200px_2.svg')
            }"
          />
        </td>
        <td style="vertical-align: middle;">
          <b class="ts-text-blue-600">{{ record.full_name_en }}</b>
        </td>
        <td style="vertical-align: middle;">
          {{ record.gender }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.date_of_birth }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.phone }}
        </td>
        <td class="text-center" style="vertical-align: middle;">
          <span class="label" :class="statusClass(record.student_status_id)">
            {{ record.student_status || '-' }}
          </span>
        </td>
      </template>
    </ts-table>
  </div>
</template>
<script>
export default {
  name: 'viewStudentList',
  props: {
    student: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      search: '',
      photoError: require('../../../assets/user_default.png')
    }
  },
  computed: {
    filteredStudents () {
      if (!this.search) return this.student

      const keyword = this.search.toLowerCase()
      return this.student.filter(record => {
        return (
          (record.full_name_en && record.full_name_en.toLowerCase().includes(keyword)) ||
          (record.card_number && record.card_number.toString().toLowerCase().includes(keyword)) ||
          (record.phone && record.phone.toString().includes(keyword)) ||
          (record.student_status && record.student_status.toLowerCase().includes(keyword))
        )
      })
    },
    columns () {
      return [
        {
          name: this.$t('school.academic.operation.classOperation.no')
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentId'),
          sortKey: 'card_number'
        },
        {
          name: this.$t('school.academic.operation.classOperation.photo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentName'),
          sortKey: 'full_name_en'
        },
        {
          name: this.$t('school.academic.operation.classOperation.sex')
        },
        {
          name: this.$t('school.academic.operation.classOperation.dob')
        },
        {
          name: this.$t('school.academic.operation.classOperation.phone')
        },
        {
          name: this.$t('school.academic.operation.classOperation.status'),
          style: 'text-align:center',
          sortKey: 'student_status'
        }
      ]
    }
  },
  methods: {
    photo (record) {
      if (record.photo) {
        return record.photo
      }

      return this.photoError
    },
    statusClass (statusId) {
      const id = Number(statusId)
      return {
        'label-green': id === 1,
        'label-warning': id === 2,
        'label-info': id === 3,
        'label-danger': id === 4,
        'label-secondary': !statusId
      }
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead tr th {
  text-transform: uppercase;
  padding: 4px 7px;
  background: rgb(218, 218, 218);
}
table tbody tr td {
  padding: 4px 7px;
}
</style>
